export default "__VITE_ASSET__BqLAmS8B__"